export default __webpack_public_path__ + "static/sonar-c1795640cedf612b8d2eb1e00d93ea41.png";